// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-list-string-answer[data-v-cd7d2d3c]{display:flex;flex-direction:column;align-items:flex-start}", ""]);
// Exports
module.exports = exports;
